"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_LOGIN_STATUS = exports.SET_ADDRESS = exports.SET_CHAIN_ID = exports.SET_RROVIDER_WALLET = exports.SET_READONLY_INITIALIZED = exports.SET_INITIALIZED = exports.REMOVE_CONTRACT = exports.ADD_CONTRACT = exports.ADD_WEB3_READONLY_INSTANCE = exports.SET_WEB3_INSTANCE = void 0;
exports.SET_WEB3_INSTANCE = 'SET_WEB3_INSTANCE';
exports.ADD_WEB3_READONLY_INSTANCE = 'ADD_WEB3_READONLY_INSTANCE';
exports.ADD_CONTRACT = 'ADD_CONTRACT';
exports.REMOVE_CONTRACT = 'REMOVE_CONTRACT';
exports.SET_INITIALIZED = 'SET_INITIALIZED';
exports.SET_READONLY_INITIALIZED = 'SET_READONLY_INITIALIZED';
exports.SET_RROVIDER_WALLET = 'SET_RROVIDER_WALLET';
exports.SET_CHAIN_ID = 'SET_CHAIN_ID';
exports.SET_ADDRESS = 'SET_ADDRESS';
exports.SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';